// extracted by mini-css-extract-plugin
module.exports = {"wrap":"list_wrap__3u97V","sectionTit":"list_sectionTit__2N3aN","footer":"list_footer__JYT5C","tabs":"list_tabs__2NF6j"};